<template>
  <div class="login-notice w-full">
    <div class="flex flex-col items-center justify-center gap-y-2 p-4">
      <div class="flex flex-col items-center mb-2">
        <img :src="loginIcon" alt="Login Arrow" class="w-8 h-8 mb-2" />
        <p class="text-lg font-bold text-black dark:text-white text-center">
          {{
            action === "view all replies"
              ? "Want to see replies?"
              : `You need to login to ${action}`
          }}
        </p>
      </div>
      <p class="text-sm text-center text-gray-600 dark:text-gray-400 mb-4">
        In order to {{ action }}, please log in or sign up and create an account.
      </p>
      <button
        @click="handleLogin"
        class="w-full text-sm md:text-base py-3 rounded-full bg-primary text-white font-semibold shadow-md hover:opacity-90 transition"
      >
        Login or Sign Up
      </button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import loginIcon from "@/assets/parler/login.svg";

defineProps({
  action: {
    type: String,
    required: false,
    default: "use this feature",
  },
});

const router = useRouter();

const handleLogin = () => {
  // Get the current route for redirect after login
  const currentRoute = router.currentRoute.value.fullPath;
  // Check if there's already a referral code in the current route
  const currentRef = router.currentRoute.value.query.ref;
  // Use site-admin referral code if not present
  const referralCode = currentRef || "cgryXSeGoy";
  // Navigate to login with redirect and referral code
  router.push({
    path: "/login",
    query: {
      redirect: currentRoute,
      ref: referralCode,
    },
  });
};
</script>

<style scoped>
.bg-primary {
  background-color: #e50038;
}

.login-notice {
  max-width: 400px;
  margin: 0 auto;
}
</style>
